import { Link } from "react-router-dom";
import "../../assets/css/category.css";
import { useState, useMemo, useEffect } from "react";
import './about.css';

const subTitle = "Learn & Grow";
const title = "Most Popular Categories";

const pastelColors = [
  "#FFE3E3",
  "#FFF6CC",
  "#E3FFE8",
  "#E3F0FF",
  "#F6E3FF",
  "#FFEEDD",
];

const STEP_COUNT = 1;

/**
 * Dynamically calculates the CARD_STEP based on CSS breakpoints.
 * CARD_STEP = (Card Width) + (Track Gap)
 */
const getCardStep = (width) => {
    // Breakpoints based on your provided CSS:
    if (width <= 360) return 130; // 120px + 10px gap
    if (width <= 480) return 150; // 140px + 10px gap
    if (width <= 768) return 174; // 160px + 14px gap
    if (width <= 992) return 198; // 180px + 18px gap
    return 245; // Default/Desktop: 220px + 25px gap
};


const Category = () => {
  const [categoryList, setCategoryList] = useState([]);
  
  // 1. DYNAMIC CARD STEP IMPLEMENTATION
  const [currentStep, setCurrentStep] = useState(getCardStep(window.innerWidth));
const [enableTransition, setEnableTransition] = useState(true); 
  useEffect(() => {
    const handleResize = () => {
      setCurrentStep(getCardStep(window.innerWidth));
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const CARD_STEP = currentStep;
  // END DYNAMIC CARD STEP IMPLEMENTATION

  // Fetch data
  useEffect(() => {
    fetch("https://kalakakshaaha.com/kks/api/v1/popular-arts-categories")
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          setCategoryList(data.categories);
        }
      })
      .catch(err => console.log(err));
  }, []);

  const baseLength = categoryList.length;

  // We create 3 copies to safely loop in middle block
  const extendedList = useMemo(() => {
    if (categoryList.length === 0) return [];
    return [...categoryList, ...categoryList, ...categoryList];
  }, [categoryList]);

  // Start in the middle block
  const [index, setIndex] = useState(baseLength); // index of first visible card inside extendedList
  const [touchStartX, setTouchStartX] = useState(null);
  const handleTouchStart = (e) => {
  setTouchStartX(e.touches[0].clientX);
};

const handleTouchEnd = (e) => {
  if (!touchStartX) return;

  const touchEndX = e.changedTouches[0].clientX;
  const diff = touchStartX - touchEndX;

  if (Math.abs(diff) > 50) { // swipe threshold
    if (diff > 0) {
      handleSlide("right"); // swipe left → next
    } else {
      handleSlide("left"); // swipe right → previous
    }
  }

  setTouchStartX(null);
};

  useEffect(() => {
    if (baseLength > 0 && index === 0) { // Check if index hasn't been initialized yet
      setIndex(baseLength);
    }
  }, [baseLength, index]);

const handleSlide = (dir) => {
  setIndex((prev) => prev + (dir === "right" ? STEP_COUNT : -STEP_COUNT));
};
useEffect(() => {
  if (!baseLength) return;

  if (index >= baseLength * 2) {
    setTimeout(() => {
      setEnableTransition(false);
      setIndex(baseLength);
    }, 300);
  }

  if (index < baseLength) {
    setTimeout(() => {
      setEnableTransition(false);
      setIndex(baseLength * 2 - 1);
    }, 300);
  }
}, [index, baseLength]);

useEffect(() => {
  if (!enableTransition) {
    requestAnimationFrame(() => setEnableTransition(true));
  }
}, [enableTransition]);



  // center card among the 3 visible => index + 1
  const centerIndexInBase = (index + 1) % baseLength;
  
  return (
    <div
      style={{
        padding: "27px 0",
        background: "transparent",
        position: "relative",
        zIndex: "0",
      }}
    >
      <div className="container">
        {/* Section Heading */}
        <div style={{ textAlign: "center", marginBottom: "40px" }}>
          <span
            style={{
              fontSize: "25px",
              fontWeight: "bold",
              color: "#f99d09ff",
            }}
          >
            {subTitle}
          </span>

          <h2

          className="category-title"
            style={{
              fontSize: "38px",
              fontWeight: "700",
              marginTop: "8px",
              color: "#ffffffff",
            }}
          >
            {title}
          </h2>
        </div>

        {/* Slider */}
        <div className="scroll-container">
          {/* Left Button */}
          <button
            className="scroll-btn left-btn"
            onClick={() => handleSlide("left")}
          >
            ❮
          </button>

          {/* Track with fade shadows */}
      <div
  className="auto-scroll-wrapper"
  onTouchStart={handleTouchStart}
  onTouchEnd={handleTouchEnd}
>

            <div
              className="auto-scroll-track"
              style={{
                // FIX: Use the dynamic CARD_STEP here
               transform: `translateX(-${index * CARD_STEP}px)`,
transition: enableTransition ? "transform 0.4s ease" : "none",
              }}
            >
              {extendedList.map((val, i) => {
                // map back to base index for color / active check
                const baseIndex = i % baseLength;
                const isActive = baseIndex === centerIndexInBase;

                return (
                <div
  key={`${val.id}-${i}`}
  className={`auto-card ${isActive ? "active-card" : ""}`}
  style={{
    background: pastelColors[baseIndex % pastelColors.length],
    cursor: "pointer"
  }}
  onClick={() => window.location.href = `/tutors/${val.category_name}`}
>

                    <img
                      src={val.img_url ? `https://kalakakshaaha.com/uploads/art_categories/${val.img_url}`:
                      "/assets/images/art/craftss.png"}
                      alt="category icon"
                      style={{
                        width: "80px",
                        height: "80px",
                        marginBottom: "12px",
                      }}
                    />
                    <br />

                  
                   <h6
                      style={{
                        fontSize: "16px",
                        fontWeight: "600",
                        color: "#333",
                        marginBottom: "5px",
                        textAlign: "center",
                        overflow: "hidden",
                        display: "-webkit-box",
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: "vertical"
                      }}
                    >
                      {val.category_name}
                    </h6>
                                      

                    <div
                      style={{
                        width: "50px",
                        height: "4px",
                        margin: "0 auto",
                        borderRadius: "4px",
                        background:
                          "linear-gradient(90deg,#ffb3c6,#ffd6a5,#caffbf,#9bf6ff,#bdb2ff)",
                      }}
                    ></div>
                  </div>
                );
              })}
            </div>
          </div>

          {/* Right Button */}
          <button
            className="scroll-btn right-btn"
            onClick={() => handleSlide("right")}
          >
            ❯
          </button>
        </div>
{/* Dot Indicators */}
<div className="slider-dots">
  {categoryList.map((_, i) => (
    <span
      key={i}
      className={`slider-dot ${
        i === centerIndexInBase ? "active-dot" : ""
      }`}
      onClick={() => {
        // We target the middle block of the extended list
        // index + 1 is the center card, so we set index to (baseLength + i - 1)
        // to make the i-th category the center card.
        setIndex(baseLength + i - 1);
      }}
      style={{ cursor: "pointer" }} // Ensure user knows it's clickable
    ></span>
  ))}
</div>
      </div>
    </div>
  );
};

export default Category;